export default function (compressSuffix, quality, acutance, isOSSImg) {
  if (isOSSImg) {
    if (compressSuffix.startsWith('Q')) {
      compressSuffix = '_' + compressSuffix.split('Q')[1] + 'Q';
    }
    return compressSuffix ? compressSuffix : quality ? '_' + quality : 'Q';
  } else {
    return compressSuffix ? compressSuffix : (quality ? 'Q' + quality : '') + (acutance ? 'S' + acutance : '');
  }
}